import React from 'react'
import Link from 'gatsby-link'
import Demo from '../../components/stick-n-slide/demo';
import Instructions from '../../components/stick-n-slide/instructions';


const IndexPage = () => (
  <div>
    <p>Stick-n-Slide is designed to be a drop-in solution for creating tables with cells that remain fixed in place as the user scrolls.</p>
    <p>Unlike other solutions, it does not require complicated modifications to your HTML, or support for CSS "position: sticky".</p>
    <Instructions />
    <Demo />
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/stick-n-slide/index.js